import React from 'react';
import VehicleForm from './components/VehicleForm';

const VehicleCreatePage: React.FC = () => {
  // Title is set at the application level
  return <VehicleForm />;
};

export default VehicleCreatePage;